import axios from 'axios';
import {v4 as uuidv4} from 'uuid';
import { AuthClientProvider } from '../../auth/AuthClientProvider';
import { Logger } from '../../utils/Logger';
import { BASE_SPA_API_DEV, BASE_SPA_API_UAT } from '../../feature-components/spa-admin/SPAConstants';

export const getSPARequestServiceAPI = async<T> (apiPath: string, env = 'none') => {
  const correlationId = uuidv4();

  var baseUrl = env === 'dev' ? BASE_SPA_API_DEV : BASE_SPA_API_UAT;

  Logger.Instance.trackTrace(`start getRequest ${apiPath}`, {
    baseUrl: baseUrl,
    correlationId: correlationId
  });

  try {
    const response = await axios.get<T>(`${baseUrl}/${apiPath}`, {
      headers: {
        'Authorization': await AuthClientProvider.getInstance().get_SPA_AuthToken(),
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "CorrelationId": correlationId
      },
    });

    Logger.Instance.trackTrace(`completed getRequest ${apiPath}`, {
      baseUrl: baseUrl,
      correlationId: correlationId
    });

    return response;
  } catch (error) {

    Logger.Instance.trackException({error: error as Error}, {
      event: `error getRequest ${apiPath}`,
      baseUrl: baseUrl,
      correlationId: correlationId
    });
    throw error;
  }
};
